// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CREATE_METERING_USAGE_CHART_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CREATE_METERING_USAGE_CHART,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      outputChart: {
        systemName: 'outputChart',
        displayName: 'Output chart',
        kind: PipelineStepDataKind.CHART,
        isMulti: false,
        isRequired: true
      },
      outputDataframe: {
        systemName: 'outputDataframe',
        displayName: 'Output data frame',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      startDate: {
        kind: 'string',
        required: true
      },
      endDate: {
        kind: 'string',
        required: true
      },
      productType: {
        kind: 'enum',
        required: false,
        choices: [
          {
            value: 'AI_ASK',
            displayName: 'AI_ASK'
          },
          {
            value: 'COMPOSE',
            displayName: 'COMPOSE'
          },
          {
            value: 'DATA_ENTRY_AGENT',
            displayName: 'DATA_ENTRY_AGENT'
          },
          {
            value: 'DEEP_RESEARCH',
            displayName: 'DEEP_RESEARCH'
          },
          {
            value: 'STRUCTURE_PREDICTION',
            displayName: 'STRUCTURE_PREDICTION'
          },
          {
            value: 'WEBHOOK_PLAYGROUND',
            displayName: 'WEBHOOK_PLAYGROUND'
          },
          {
            value: 'GENERATIVE_MODELS',
            displayName: 'GENERATIVE_MODELS'
          },
          {
            value: 'UNCLAIMED',
            displayName: 'UNCLAIMED'
          }
        ]
      },
      userId: {
        kind: 'domain',
        required: false,
        types: [
          'USER'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
